var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplacementAdvisorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 190 190",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,187.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M782 1859 c-91 -14 -220 -60 -307 -110 -250 -142 -411 -374 -461 -662 -36 -207 13 -467 120 -635 22 -35 30 -41 41 -32 12 10 9 19 -15 58 -43 70 -86 186 -106 281 -22 114 -15 314 16 421 95 329 374 581 706 640 101 18 308 8 399 -19 89 -26 215 -88 283 -139 62 -47 57 -52 -57 -52 -43 0 -80 -3 -83 -6 -3 -3 -4 -14 -1 -24 5 -17 13 -18 112 -14 159 8 155 6 147 62 -24 185 -28 202 -45 202 -10 0 -20 -2 -23 -5 -2 -3 1 -41 7 -85 6 -44 10 -80 8 -80 -1 0 -24 16 -50 37 -67 51 -213 119 -308 144 -93 24 -286 33 -383 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693 1452 c-9 -6 2 -37 40 -112 76 -153 92 -223 92 -405 0 -171 -13 -238 -75 -371 -51 -111 -105 -186 -191 -270 -116 -111 -210 -167 -369 -220 -80 -27 -95 -28 -260 -28 -170 0 -177 0 -270 32 -123 41 -328 158 -309 176 2 3 44 6 92 7 85 2 87 2 87 26 l0 24 -117 -7 c-65 -3 -120 -8 -122 -10 -2 -2 2 -60 9 -129 12 -114 14 -125 33 -125 19 0 20 4 13 80 -3 44 -4 80 -1 80 3 0 27 -16 54 -35 67 -48 204 -111 298 -137 64 -17 106 -21 233 -21 186 0 262 17 415 92 229 114 396 302 474 536 78 235 64 477 -43 699 -51 107 -66 128 -83 118z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043 1138 l-193 -192 -93 91 c-108 107 -141 120 -212 85 -53 -26 -80 -76 -72 -135 5 -37 21 -57 164 -199 l159 -158 54 0 54 0 244 243 c134 133 250 254 258 269 8 15 14 46 14 69 0 35 -6 48 -39 80 -35 36 -43 39 -92 39 l-53 0 -193 -192z m310 134 c29 -26 39 -60 27 -96 -10 -33 -455 -484 -498 -506 -45 -23 -74 -4 -225 149 -140 140 -147 149 -147 187 0 55 40 94 94 94 36 0 47 -8 143 -102 l104 -102 197 196 c108 108 204 198 212 201 24 9 72 -2 93 -21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplacementAdvisorLogo);
export default __webpack_public_path__ + "static/media/replacement_advisor_logo.78f0f43a5162aa16288429a5488a1d5f.svg";
export { ForwardRef as ReactComponent };